import { Injectable } from '@angular/core';

@Injectable()
export class TreeDataHelperService {

    findNode(data, selector): any {
        console.log(data,selector)

        let nodes = data?.filter(x=>selector.data.name===x.data.name);
        if (nodes && nodes.length === 1) {
            return nodes[0];
        }

        let foundNode = null;

        data.forEach( d => {
            if (!foundNode) {
                foundNode = this.findNode(d.children, selector);
            }
        });

        return foundNode;
    }

    findParent(data, nodeSelector) {
        let node = this.findNode(data, nodeSelector);
        if (!node) {
            return null;
        }

        return node.parent;
    }

    findChildren(data, selector) {
        let traverseChildren = function (node) {
            let names = [];
            if (node.children) {
                node.children.forEach(c => {
                    names.push(c.data.name);
                    names = names.concat(traverseChildren(c));
                });
            }
            return names;
        };

        let foundNode = this.findNode(data, selector);
        if (foundNode) {
            return traverseChildren(foundNode);
        } else {
            return [];
        }
    }
}
